import { Droppable } from "@hello-pangea/dnd";
import DealCard from "@/components/pipeline/DealCard";
import { fmtCurrency } from "@/lib/format";
import { cn } from "@/lib/utils";
import { ClipboardList } from "lucide-react";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function StageColumn({ stage, cards, requiredCount, canMove, onOpen }) {
  const total = cards.reduce((s, d) => s + (Number(d.amount) || 0), 0);
  return (
    <div className="w-72 shrink-0 flex flex-col" data-testid={`stage-column-${slug(stage)}`}>
      <div className="px-1 mb-2">
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-slate-700">{stage}</span>
          <span className="text-xs font-bold text-slate-500 bg-slate-100 rounded-full px-2 py-0.5" data-testid={`stage-count-${slug(stage)}`}>{cards.length}</span>
        </div>
        <div className="flex items-center justify-between text-xs text-slate-400 mt-0.5">
          <span>{fmtCurrency(total)}</span>
          {requiredCount > 0 && <span className="inline-flex items-center gap-1" title="This stage requires extra details"><ClipboardList className="h-3 w-3" /> {requiredCount} required</span>}
        </div>
      </div>
      <Droppable droppableId={stage}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            data-testid={`stage-drop-${slug(stage)}`}
            className={cn(
              "space-y-2 rounded-xl p-2 min-h-[120px] flex-1 transition-colors duration-150",
              snapshot.isDraggingOver ? "bg-teal/10 ring-2 ring-teal/30" : "bg-slate-100/70"
            )}
          >
            {cards.map((d, i) => <DealCard key={d.id} deal={d} index={i} canMove={canMove} onOpen={onOpen} />)}
            {provided.placeholder}
            {cards.length === 0 && !snapshot.isDraggingOver && <div className="text-center text-xs text-slate-300 py-6">Drop deals here</div>}
          </div>
        )}
      </Droppable>
    </div>
  );
}
